// @flow
import React from 'react'
import type { Node } from 'react'
import styled from 'styled-components'
import cx from 'classnames'

import { myTheme } from '../../styles'

const { fontSize } = myTheme

const StyledCaption = styled.h6`
  font-size: ${fontSize.seven};
  text-transform: uppercase;
`

const styles = { base: 'mb0' }

type Props = {
  children: Node,
  className: string,
}

const Caption = ({ children, className }: Props) => (
  <StyledCaption className={cx(styles.base, className)}>
    {children}
  </StyledCaption>
)

export default Caption



// WEBPACK FOOTER //
// ./src/components/typography/caption.js